import { render, staticRenderFns } from "./BhandargharProducts.vue?vue&type=template&id=2b68625c&"
import script from "./BhandargharProducts.vue?vue&type=script&lang=js&"
export * from "./BhandargharProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports